import React, { useEffect, useState } from 'react';
import c from './index.module.scss';
import { clsx } from 'clsx';
import Image from '@/src/shared/components/Image';
import { NextSeo } from 'next-seo';
import HomeHeader from 'src/shared/components/HomeHeader';
import { RichardSilverTestimonial } from './richard-silver-testimonial';
import testimonialData from './testimonialData';
import RestOfPage from './rest';
import Reviews from '../Landings/Reviews';

export default function TestimonialPageComponent(props) {
  const [isMobile, setIsMobile] = useState(false);
  const [hiddenMobile, setHiddenMobile] = useState(true);

  const [renderRest, setRenderRest] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
    setTimeout(() => {
      setRenderRest(true);
    }, 3000);
  }, []);

  const dataColumns = [
    testimonialData.slice(0, 9),
    testimonialData.slice(9, 19),
    testimonialData.slice(20, 30),
  ];

  return (
    <>
      <NextSeo
        title="Roomvu Reviews | Lead Generation Success Stories"
        description="See reviews of Roomvu for lead generation success stories"
        openGraph={{
          title: 'Roomvu Reviews | Lead Generation Success Stories',
          description:
            'See reviews of Roomvu for lead generation success stories',
        }}
      />
      <HomeHeader />
      <div className={c.container}>
        <h2 className={c.mainTitle}>Lead Generation Success Stories</h2>

        <div className={c.richardSilverTestimonialContainer}>
          <RichardSilverTestimonial
            variant="testimonial-page"
            classes={{
              container: c.richardSilverTestimonial,
              content: c.richardSilverTestimonialContent,
            }}
          />
        </div>

        <div className={c.columnsContainer}>
          {dataColumns.map((dataColumn, index) => (
            <div
              key={index}
              className={clsx(
                c.column,
                index > 0 && hiddenMobile ? c.hiddenMobile : ''
              )}
            >
              {dataColumn.map((card) => (
                <div
                  key={card.personName}
                  className={clsx(
                    c.card,
                    card.cardColor === 'white' ? c.cardWhite : c.cardBlue
                  )}
                >
                  <div>
                    <div className={c.title}>
                      <div className={c.avatar}>
                        <Image
                          objectFit="cover"
                          className={c.rounded}
                          src={`/images/testimonials/${card.avatarUrl}`}
                          fill
                          alt={card.personName}
                        />
                      </div>

                      <div className={c.titlesContainer}>
                        <div className={c.titleAndStar}>
                          <div className={c.fullName}>{card.personName}</div>
                          <div className={c.starsContainer}>
                            <Image
                              className={c.rounded}
                              src={`/images/testimonials/${card.stars}.svg`}
                              fill
                              alt={`${card.stars} stars out of 5`}
                            />
                          </div>
                        </div>

                        <div className={c.description}>{card.description}</div>
                      </div>
                    </div>
                    <div className={c.locationContainer}>
                      <div className={c.icon}>
                        <Image
                          className={c.rounded}
                          src="/images/testimonials/location-blue.svg"
                          fill
                          alt=""
                        />
                      </div>
                      <div className={c.locationName}>{card.locationName}</div>
                    </div>
                    <div className={c.testimonialContent}>
                      {card.testimonialContent}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        {hiddenMobile && (
          <div className={clsx(c.seeMoreButton, c.mobileOnly)}>
            <button
              onClick={() => {
                setHiddenMobile(false);
              }}
            >
              See More
            </button>
          </div>
        )}

        <div className={c.reviews}>
          <div className={c.divider} />
          <Reviews />
        </div>

        {renderRest && <RestOfPage isMobile={isMobile} />}
      </div>
    </>
  );
}
